'use strict';

/**
 * P4.1 — Follow/Unfollow Toggle.
 *
 * Stil/Struktur 1:1 zu favorite.js (delegated-click + fetch + toastr). Per-Button
 * data-attribute halt die beiden URLs + den CSRF-Token; isFollowing-State ist im
 * data-is-following gespeichert und wird nach jeder Antwort synchron mit der
 * Server-Antwort aktualisiert.
 */
export default class UserFollow {
    initialize() {
        let instance = this;
        document.addEventListener('click', (event) => {
            let selector = '.js-user-follow-toggle';
            let target = null;
            if (event.target && event.target.matches && event.target.matches(selector)) {
                target = event.target;
            } else if (event.target && event.target.closest && event.target.closest(selector)) {
                target = event.target.closest(selector);
            }
            if (target) {
                instance.toggle(target);
            }
        });
    }

    toggle(button) {
        if (button.disabled) {
            return;
        }
        let isFollowing = button.dataset.isFollowing === '1';
        let url = isFollowing ? button.dataset.unfollowPath : button.dataset.followPath;
        let token = button.dataset.token || '';

        if (!url) {
            if (typeof toastr !== 'undefined') {
                toastr.error('Folgen-Aktion konnte nicht ausgeführt werden!');
            }
            return;
        }
        let container = button.closest('.js-user-follow');
        let countEl = container ? container.querySelector('.user-follow__count') : null;
        let labelEl = button.querySelector('.user-follow__label');
        let iconEl = button.querySelector('i');

        button.disabled = true;

        fetch(url, {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ _token: token })
        }).then(response => {
            if (!response.ok) {
                throw new Error('Netzwerk-Antwort war nicht in Ordnung');
            }
            return response.json();
        }).then(data => {
            if (parseInt(data.error, 10) > 0) {
                throw new Error(data.message || 'Unbekannter Fehler');
            }
            let nowFollowing = !!data.isFollowing;
            button.dataset.isFollowing = nowFollowing ? '1' : '0';
            button.classList.toggle('isFollowing', nowFollowing);
            button.classList.toggle('btn-primary', nowFollowing);
            button.classList.toggle('btn-outline-primary', !nowFollowing);
            if (labelEl) {
                labelEl.textContent = nowFollowing ? 'Folge ich' : 'Folgen';
            }
            if (iconEl) {
                iconEl.classList.toggle('fa-user-check', nowFollowing);
                iconEl.classList.toggle('fa-user-plus', !nowFollowing);
            }
            if (countEl && typeof data.followerCount !== 'undefined') {
                countEl.textContent = data.followerCount;
            }
            if (typeof toastr !== 'undefined') {
                if (typeof toastr !== 'undefined') {
                toastr.success(
                    nowFollowing
                        ? 'Du folgst jetzt diesem User. Neue Bilder, Geschichten und Umfragen erscheinen in deinem Feed.'
                        : 'Du folgst diesem User nicht mehr.'
                );
            }
            }
        }).catch(error => {
            if (typeof toastr !== 'undefined') {
                toastr.error(error.toString(), 'Folgen fehlgeschlagen', { 'timeOut': 0 });
            }
            console.error('UserFollow error:', error);
        }).finally(() => {
            button.disabled = false;
        });
    }
}
